import { RouteComponentProps } from 'react-router-dom';
import { bindActionCreators, combineReducers } from 'redux';

import {IBannerProps, SORT_STATE} from '@abb/common-ux';
import { RequestLogFilterValue } from '@module/analysis/RequestLogFilter';
import { IUserToken } from '@module/authentication/models';
import { IUploadResult, IUserPermissions } from '@module/shared/';

const initialUploadState: IUploadState = {
  uploadResultStatus: {
    TotalParts: 0,
    MatchedParts: 0,
    UnMatchedParts: 0,
    SparePartsUploadID: ''
  }
};

export interface IConnectedComponent extends RouteComponentProps<any> {
  history: any;
  dispatch: any;
  loggedInUser: IUserToken;
  userPermissions: IUserPermissions;
}

interface IUploadState {
  uploadResultStatus: IUploadResult | null;
}

export interface IBannerState {
  banners: IBannerProps[];
}

export interface IRequestInfoState {
  requestId: string;
  emailAddress: string;
}

const initialBannerState: IBannerState = { banners: [] };

const initialRequestState: IRequestInfoState = {
  requestId: '',
  emailAddress: ''
};

function bannerReducer(state = initialBannerState, action: any): IBannerState {
  switch (action.type) {
    case 'ADD_BANNER':
      return { banners: [...action.banners] };
    case 'REMOVE_BANNER':
      const bannas = [ ...state.banners ];
      for (const banner of action.banners) {
        bannas.splice(bannas.findIndex(b => b.id === banner.id), 1);
      } 
      return { banners: bannas};
    case 'BANNER_CLEAR':
      return initialBannerState;
    default:
      return state;
  }
}

function uploadReducer(state = initialUploadState, action: any): IUploadState {
  switch (action.type) {
    case 'UPLOAD_RESULT':
      return { ...state, uploadResultStatus: action.uploadResultStatus };
    case 'UPLOAD_CLEAR':
      return { ...initialUploadState };
    default:
      return state;
  }
}

function requestInfoReducer(state = initialRequestState, action: any): IRequestInfoState {
  switch (action.type) {
    case 'REQUEST_INFO':
      return { ...state, requestId: action.requestId, emailAddress: action.emailAddress };
    default:
      return state;
  }
}

/* For user authorization - Starts */
export interface IAuthenticationProps {
  login: (user: any) => Promise<void>;
  logout: (user: any) => void;
  tokenExpired: () => void;
  children: any;
  context: any;
}

interface IUserState {
  loggedInUser: IUserToken | null;
  userPermissions: IUserPermissions | null;
}

const initialUserState: IUserState = {
  loggedInUser: null,
  userPermissions: null
};

function userReducer(state = initialUserState, action: any): IUserState {
  switch (action.type) {
    case 'USER_LOGIN':
      return { ...state, loggedInUser: action.loggedInUser, userPermissions: action.userPermissions };
    default:
      return state;
  }
}
/* For user authorization - Ends */

export interface IRequestLogProps {
  filter: RequestLogFilterValue;
  currentPage: number;
  sortField: string;
  sortDirection: SORT_STATE;
}

export const initialRequestLogState: IRequestLogProps = {
  filter: new RequestLogFilterValue('Pending'),
  currentPage: 0,
  sortField: 'requestID',
  sortDirection: 'desc'
};

function requestLogFilterReducer(state = initialRequestLogState, action: any): IRequestLogProps {
  switch (action.type) {
    case 'REQUEST_LOG_FILTER_UPDATE':
      return { ...state, filter: action.filter };
    case 'REQUEST_LOG_CLEAR':
      return { ...initialRequestLogState };
    case 'PAGE_CHANGE':
      return { ...state, currentPage: action.currentPage};
    case 'PAGE_AND_FILTER_CHANGE':
      return { ...state, currentPage: action.currentPage, filter: action.filter };
    case 'SORT_CHANGE':
      return { ...state, sortField: action.sortField, sortDirection: action.sortDirection };
    default:
      return state;
  }
}

export const reducers = combineReducers({
  bannerState: bannerReducer,
  uploadState: uploadReducer,
  requestInfoState: requestInfoReducer,
  userState: userReducer,
  requestLogState: requestLogFilterReducer
});
